import CurrentUser from './currentUser'
import axios from 'axios'
import router from '@/router'
import { eventsHub } from '../main'

const state = {
  currentUser: null,
  keywordRecherche: null
}

const getters = {
  // Acces via  this.$store.getters.currentUser
  currentUser(state) {
    if (state.currentUser == null) {
      return null
    } else {
      return state.currentUser
    }
  },
  estAuthentifie(state) {
    if (state.currentUser == null) {
      return false
    } else {
      return state.currentUser != null
    }
  },

  role(state) {
    return state.currentUser == null ? null : state.currentUser.role
  },

  valideTypeClient: state => typeClient => {
    if (state.currentUser == null) {
      return false
    }

    switch (typeClient) {
      case 'TITULAIRE_POUR_REVENTE':
        return (
          state.currentUser.clientData.typeClient === 'TITULAIRE_POUR_REVENTE'
        )

      case 'PARTICULIER':
        return state.currentUser.clientData.typeClient === 'PARTICULIER'
      case 'BOUTIQUE_HORS_TAXE':
        return state.currentUser.clientData.typeClient === 'BOUTIQUE_HORS_TAXE'
      case 'LIEU_DE_CULTE':
        return state.currentUser.clientData.typeClient === 'LIEU_DE_CULTE'
      case 'POUVOYEUR_DE_NAVIRE':
        return state.currentUser.clientData.typeClient === 'POUVOYEUR_DE_NAVIRE'
      default:
        return false
    }
  },

  isDemandeAutorise(state) {
    if (state.currentUser.demandeur.indDemandeIPAutorise == true) {
      return true
    } else {
      return false
    }
  },

  codeUsager(state) {
    if (state.currentUser == null) {
      return null
    } else {
      return state.currentUser.codeUsager
    }
  },
  usagerConnecte(state) {
    if (state.currentUser == null) {
      return null
    } else {
      return state.currentUser.demandeur
    }
  },
  usagerConnecteInfosJDE(state) {
    if (state.currentUser == null) {
      return null
    } else {
      return state.currentUser.infosClientJDE
    }
  },
  languePreferee(state) {
    if (state.currentUser == null) {
      return null
    } else {
      return state.currentUser.languePreferee
    }
  },
  accessToken(state) {
    if (state.currentUser == null) {
      return null
    } else {
      return state.currentUser.accessToken
    }
  },
  keywordRecherche(state) {
    return state.keywordRecherche
  }
}

const actions = {
  login({ commit }, usagerData) {
    commit('mLogin', usagerData)
  },
  logout({ commit }) {
    commit('mLogout')
    if (router.currentRoute.name != 'login') {
      console.log('logout et pas page /login, redirection vers /login')
      router.push({ name: 'login' })
    }
  },
  tokenExpire({ commit }) {
    commit('mLogout')
    router.push({ name: 'tokenExpire' })
  },
  rechercheProduit({ commit }) {
    if (router.currentRoute.name != 'rechercheProduit') {
      router.push({ name: 'rechercheProduit' })
    }
    eventsHub.$emit('rechercherProduit')
  }
}

const mutations = {
  mLogin(state, usagerData) {
    state.currentUser = CurrentUser.from(usagerData)
    state.keywordRecherche = null
  },
  mLogout(state) {
    state.currentUser = null
    axios.defaults.headers.Authorization = null
    state.keywordRecherche = null
  },
  mRechercherProduit(state, keywordRecherche) {
    state.keywordRecherche = keywordRecherche
  }
}

export default {
  state,
  mutations,
  getters,
  actions
}
